import { uploadBrandAsset as uploadBrandAssetViaSettings } from '@/services/edgeFunctionWrappers/settingsManagementWrapper';
import type { AthleteBackgroundKey } from '@/lib/athleteTheme';

export const uploadLogo = async (
  gymId: string, 
  file: File, 
  variant: 'light' | 'dark'
): Promise<string | null> => {
  try {
    if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || file.size > 3 * 1024 * 1024) return null;
    const base64 = await readFileAsBase64(file);
    return await uploadBrandAssetViaSettings(gymId, {
      slot: `logo-${variant}`,
      fileName: file.name,
      contentType: file.type as 'image/png' | 'image/jpeg' | 'image/webp',
      base64,
    });
  } catch (error) {
    console.error('Error in uploadLogo:', error);
    return null;
  }
};

export const uploadBrandAsset = async (
  gymId: string,
  file: File,
  slot: AthleteBackgroundKey,
): Promise<string | null> => {
  if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || file.size > 3 * 1024 * 1024) {
    throw new Error('Invalid brand asset');
  }

  const base64 = await readFileAsBase64(file);
  return uploadBrandAssetViaSettings(gymId, {
    slot,
    fileName: file.name,
    contentType: file.type as 'image/png' | 'image/jpeg' | 'image/webp',
    base64,
  });
};

function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Unable to read image'));
    reader.onload = () => resolve(String(reader.result).split(',')[1] ?? '');
    reader.readAsDataURL(file);
  });
}
